import { Icon, Pill } from "./ui-kit";
import { cn } from "../lib/utils";

export function AiBlock({ block }) {
  const t = block.type;
  if (t === "heading")
    return <h4 className="text-base font-bold text-mim-navy mt-1">{block.text}</h4>;
  if (t === "paragraph")
    return <p className="text-sm text-mim-navy/90 leading-relaxed">{block.text}</p>;
  if (t === "bullets")
    return (
      <ul className="space-y-1.5">
        {(block.items || []).map((it, i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-mim-navy/90">
            <Icon name="Check" className="w-4 h-4 text-mim-green mt-0.5 shrink-0" />
            <span>{it}</span>
          </li>
        ))}
      </ul>
    );
  if (t === "formula")
    return (
      <div className="bg-mim-navy text-white rounded-2xl px-5 py-4 text-center my-1">
        <div className="text-[10px] font-bold uppercase tracking-widest text-mim-cyan mb-1">Formula</div>
        <div className="text-xl font-bold tracking-wide">{block.text}</div>
      </div>
    );
  if (t === "example")
    return (
      <div className="bg-mim-soft rounded-2xl px-4 py-3 border border-mim-blue/15">
        <div className="text-[10px] font-bold uppercase tracking-widest text-mim-blue mb-1">Example</div>
        <p className="text-sm text-mim-navy/90">{block.text}</p>
      </div>
    );
  if (t === "callout") {
    const style = block.style || "info";
    const map = {
      tip: { tone: "green", icon: "Lightbulb", label: "Tip" },
      warning: { tone: "coral", icon: "TriangleAlert", label: "Watch out" },
      info: { tone: "blue", icon: "Info", label: "Note" },
    }[style] || { tone: "blue", icon: "Info", label: "Note" };
    const bg = { green: "bg-mim-green/10 border-mim-green/20", coral: "bg-mim-coral/10 border-mim-coral/20", blue: "bg-mim-soft border-mim-blue/20" }[map.tone];
    const fg = { green: "text-mim-green", coral: "text-mim-coral", blue: "text-mim-blue" }[map.tone];
    return (
      <div className={cn("rounded-2xl px-4 py-3 border flex gap-2.5", bg)}>
        <Icon name={map.icon} className={cn("w-4 h-4 mt-0.5 shrink-0", fg)} />
        <div>
          <div className={cn("text-[10px] font-bold uppercase tracking-widest mb-0.5", fg)}>{map.label}</div>
          <p className="text-sm text-mim-navy/90">{block.text}</p>
        </div>
      </div>
    );
  }
  if (t === "try")
    return (
      <div className="rounded-2xl px-4 py-3 border border-mim-purple/25 bg-mim-purple/5">
        <div className="text-[10px] font-bold uppercase tracking-widest text-mim-purple mb-1 flex items-center gap-1">
          <Icon name="Dumbbell" className="w-3 h-3" /> Try this
        </div>
        <p className="text-sm text-mim-navy/90">{block.text}</p>
      </div>
    );
  if (t === "table" && Array.isArray(block.rows))
    return (
      <div className="overflow-hidden rounded-2xl border border-mim-line">
        <table className="w-full text-sm">
          <tbody>
            {block.rows.map((r, i) => (
              <tr key={i} className={i === 0 ? "bg-mim-soft font-semibold" : "border-t border-mim-line"}>
                {r.map((c, j) => <td key={j} className="px-3 py-2 text-mim-navy/90">{c}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  return <p className="text-sm text-mim-navy/90">{block.text}</p>;
}

export function AiBlocks({ blocks }) {
  return <div className="space-y-3">{(blocks || []).map((b, i) => <AiBlock key={i} block={b} />)}</div>;
}
